import { createContext, useContext } from 'react';

export const CustomNotificationContext = createContext(undefined);

export const useCustomNotificationContext = () => {
    const context = useContext(CustomNotificationContext);

    if (!context) {
        throw new Error('useCustomNotificationContext must be used within InterruptProcessModal.');
    }

    return context;
};
